/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Values: 0=Company, 1=Form, 2=Template, 3=DoubleMateriality
 * @export
 * @enum {number}
 */

export enum EntityType {
    Company = 0,
    Form = 1,
    Template = 2,
    DoubleMateriality = 3
}


